import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_NoteTemplate, defaultItem_NoteTemplate } from '@app/advisor-content-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_NoteTemplate } from '../../../_entity/note-template/ModuleFE_NoteTemplate.js';
import { Renderer_NoteTemplateHeader } from './renderers/Renderer_NoteTemplateHeader/Renderer_NoteTemplateHeader.js';
import { Editor_NoteTemplate } from '../../editors/Editor_NoteTemplate/Editor_NoteTemplate.js';
import './Manager_NoteTemplate.scss';
import { LL_V_L } from "@nu-art/thunderstorm-frontend/index";
const Editor_AdvisorSnippet_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-note-template', children: [_jsx(Renderer_NoteTemplateHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_NoteTemplate, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_NoteTemplate = createWorkHubManager({
    module: ModuleFE_NoteTemplate,
    dbDef: DBDef_NoteTemplate,
    defaultItem: defaultItem_NoteTemplate,
    labelResolver: (noteTemplate) => noteTemplate.title ?? "New Note Template",
    EditorComponent: Editor_AdvisorSnippet_Wrapper,
});
//# sourceMappingURL=Manager_NoteTemplate.js.map